var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mImgCurrer",
    class: _vm.isMobile && 'wap'
  }, [_c('input', {
    ref: "inputFile",
    staticStyle: {
      "width": "1px",
      "height": "1px",
      "border": "none",
      "opacity": "0"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.putImgToCanv,
      "input": _vm.putImgBlur
    }
  }), _vm.isModal ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isModal,
      expression: "isModal"
    }],
    ref: "mask",
    class: _vm.isModal === true ? 'mask img-cutter-main' : ''
  }, [_c('div', {
    class: _vm.isModal === true ? 'dialogBoxModal' : 'dialogBox'
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "enter-class": "fade-in-enter",
      "enter-active-class": "fade-in-active",
      "leave-class": "fade-out-enter",
      "leave-active-class": "fade-out-active"
    }
  }, [_c('div', {
    ref: "dialogMainModalRef",
    class: _vm.isModal === true ? 'dialogMainModal' : 'dialogMain',
    style: 'width:' + (_vm.isModal === true ? _vm.remTran(_vm.boxWidth + 150) : _vm.remTran(_vm.boxWidth)) + 'px'
  }, [_c('div', {
    staticClass: "toolMain"
  }, [_vm.isModal === true ? _c('div', {
    staticClass: "tool-title"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Crop your image")) + " "), _c('span', {
    staticClass: "closeIcon",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "close"
    }
  })], 1)]) : _vm._e(), _c('div', {
    ref: "toolBox",
    staticClass: "toolBox",
    style: {
      height: _vm.remTran(_vm.boxHeight),
      width: _vm.remTran(_vm.boxWidth)
    },
    on: {
      "mousemove": _vm.controlBtnMouseMove,
      "mouseup": _vm.controlBtnMouseUp,
      "mouseleave": _vm.controlBtnMouseUp
    }
  }, [_vm.isMobile ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.drawImg.img && _vm.dropImg.active !== true && _vm.controlBox.disable == true && _vm.toolBox.disable == true,
      expression: "drawImg.img && dropImg.active !== true && controlBox.disable == true && toolBox.disable == true"
    }],
    staticClass: "dockMain",
    on: {
      "mouseenter": _vm.dropImgOff
    }
  }, [_vm.rate ? _c('div', {
    staticClass: "dockBtn"
  }, [_c('div', {
    staticClass: "dockBtn-item",
    on: {
      "click": function ($event) {
        return _vm.onZoom(10);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "zoom"
    }
  })], 1), _c('div', {
    staticClass: "dockBtn-item",
    on: {
      "click": function ($event) {
        return _vm.onZoom(-10);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "zoomOut"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.drawImg.img != null,
      expression: "drawImg.img != null"
    }],
    ref: "toolBoxControl",
    staticClass: "toolBoxControl",
    style: {
      pointerEvents: _vm.moveAble ? 'auto' : 'none'
    },
    on: {
      "mousedown": _vm.toolBoxMouseDown,
      "mouseup": _vm.toolBoxMouseUp,
      "mousemove": _vm.toolBoxMouseMove,
      "mouseleave": _vm.toolBoxMouseLeave,
      "touchstart": _vm.toolBoxMouseDown,
      "touchmove": _vm.toolBoxMouseMove,
      "touchend": _vm.toolBoxMouseLeave
    }
  }, [_c('div', {
    staticClass: "toolBoxControlBox"
  }, [_c('div', {
    staticClass: "controlBox"
  }, [_c('div', {
    staticClass: "controlBoxInnerLine controlBoxInnerLineTop"
  }), _c('div', {
    staticClass: "controlBoxInnerLine controlBoxInnerLineBottom"
  }), _c('div', {
    staticClass: "controlBoxInnerLine controlBoxInnerLineLeft"
  }), _c('div', {
    staticClass: "controlBoxInnerLine controlBoxInnerLineRight"
  }), _c('div', {
    staticClass: "selectArea"
  }, [_vm._v("W:" + _vm._s(_vm.showToolBoxWidth) + "   H:" + _vm._s(_vm.showToolBoxHeight))]), _vm.sizeChange === true ? _c('div', {
    staticClass: "leftUp controlBtn",
    attrs: {
      "data-name": "leftUp"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'leftUp');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true ? _c('div', {
    staticClass: "leftDown controlBtn",
    attrs: {
      "data-name": "leftDown"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'leftDown');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true ? _c('div', {
    staticClass: "rightUp controlBtn",
    attrs: {
      "data-name": "rightUp"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'rightUp');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true ? _c('div', {
    staticClass: "rightDown controlBtn",
    attrs: {
      "data-name": "rightDown"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'rightDown');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true && !_vm.rate && _vm.toolBox.width > 20 ? _c('div', {
    staticClass: "topCenter controlBtn",
    attrs: {
      "data-name": "topCenter"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'topCenter');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true && !_vm.rate && _vm.toolBox.width > 20 ? _c('div', {
    staticClass: "downCenter controlBtn",
    attrs: {
      "data-name": "downCenter"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'downCenter');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true && !_vm.rate && _vm.toolBox.height > 20 ? _c('div', {
    staticClass: "leftCenter controlBtn",
    attrs: {
      "data-name": "leftCenter"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'leftCenter');
      }
    }
  }) : _vm._e(), _vm.sizeChange === true && !_vm.rate && _vm.toolBox.height > 20 ? _c('div', {
    staticClass: "rightCenter controlBtn",
    attrs: {
      "data-name": "rightCenter"
    },
    on: {
      "mousedown": function ($event) {
        return _vm.controlBtnMouseDown($event, 'rightCenter');
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "toolBoxControlLine toolBoxControlLineItem-1"
  }), _c('div', {
    staticClass: "toolBoxControlLine toolBoxControlLineItem-2"
  }), _c('div', {
    staticClass: "toolBoxControlLine toolBoxControlLineItem-3"
  }), _c('div', {
    staticClass: "toolBoxControlLine toolBoxControlLineItem-4"
  })])]), _c('canvas', {
    ref: "canvasSelectBox",
    staticClass: "canvasSelectBox",
    attrs: {
      "width": _vm.boxWidth,
      "height": _vm.boxHeight
    },
    on: {
      "mousedown": function ($event) {
        return _vm.dropImgOn($event);
      },
      "mouseup": function ($event) {
        return _vm.dropImgOff($event);
      },
      "mousemove": function ($event) {
        return _vm.dropImgMove($event);
      },
      "touchstart": function ($event) {
        return _vm.dropImgOn($event);
      },
      "touchend": function ($event) {
        return _vm.dropImgOff($event);
      },
      "touchmove": function ($event) {
        return _vm.dropImgMove($event);
      }
    }
  }), _c('canvas', {
    ref: "canvas",
    staticClass: "canvas",
    attrs: {
      "width": _vm.boxWidth,
      "height": _vm.boxHeight
    }
  })])]), _c('div', {
    staticClass: "i-dialog-footer"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('span', {
    on: {
      "click": function ($event) {
        return _vm.cropPicture(false);
      }
    }
  }, [_vm._t("confirm", function () {
    return [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "disabled": !_vm.drawImg.img
      }
    }, [_vm._v(_vm._s(_vm.$lang("Crop image")))])];
  })], 2)])])])]), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };